import { render, staticRenderFns } from "./OAplikaci.vue?vue&type=template&id=2aa12232&"
import script from "./OAplikaci.vue?vue&type=script&lang=ts&"
export * from "./OAplikaci.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports